import { defineMessages } from 'react-intl';

const messages = defineMessages({
  usernameAlreadyExists: {
    description: 'Error message indicating the username already exists in the system',
    defaultMessage: 'The username {username} is already in use.',
    id: 'HB+DW6',
  },
});

export default ({ username }) => {
  return {
    ...messages.usernameAlreadyExists,
    values: { username },
  };
};
